import { render } from "./NucleoC.vue?vue&type=template&id=44d47092"
import script from "./NucleoC.vue?vue&type=script&lang=js"
export * from "./NucleoC.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aplicaciones_mides/tu-mides/frontend-tumides/tuMIDES/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__